import { useResourceReservationRequestInfoForProduct } from "@@/resource-reservations/state/resource-reservation-info/use-resource-reservation-info-for-product";
import { browserLogger } from "@@/settings";
import type {
    BookableSession,
    BookableSettings,
    DurationInMinutes,
} from "@towni/common";
import {
    emptyArrayOf,
    isSessionAvailable,
    minSessionTimeRange,
    sortBy,
} from "@towni/common";
import { useMemo } from "react";
import { useBookingContext } from "../booking-context";

const useBookingForSessions = () => {
    const state = useBookingContext(state => ({
        sku: state.sku,
        session: state.session,
        bookable: state.bookable,
        product: state.product,
        sessions: state.sessions,
        ignoreOrder: state.ignoreOrder,
    }));

    const data = useResourceReservationRequestInfoForProduct(
        state.product._id,
        state.ignoreOrder,
    );

    const sessions = useMemo(() => {
        if (data.isPending) return emptyArrayOf<BookableSession>();
        //This is to prevent a reload bug TODO ASK JAKOB
        //When blocking towni domain and trying to open the booking wizard
        if (data.isLoadingError) {
            browserLogger.error("Loadning sessions error", data.error);
            return emptyArrayOf<BookableSession>();
        }

        const result = state.sessions
            .filter((session: BookableSession) => {
                const override: BookableSettings = {
                    ...session.bookableSettings,
                    advanceNotice: 0 as DurationInMinutes,
                    prepTime: 0 as DurationInMinutes,
                };
                return isSessionAvailable({
                    settings: override,
                    timeRange: minSessionTimeRange(session),
                    ignoreSessionAvailability: false,
                });
            })
            .sort(sortBy(f => f.start.unix))
            .filter(f => f.status.type === "ACTIVE");

        return result;
    }, [data.error, data.isLoadingError, data.isPending, state.sessions]);

    return [sessions, data.isPending] as const;
};

export { useBookingForSessions };
